import React from "react";
import PropTypes from "prop-types";
import Ripple from "material-ripple-effects";

export default function NavItem({ children, active, ripple, ...rest }) {
    const rippleEffect = new Ripple();

    const baseClasses =
        "sm:px-5 px-2 sm:py-2 flex gap-1 items-end sm:text-md text-sm uppercase rounded-lg font-body transition-colors duration-200 leading-[1]";

    const inactiveClasses = "text-white hover:bg-white hover:text-black";
    const activeClasses = "bg-white text-black";

    return (
        <li
            {...rest}
            className={`${baseClasses} ${
                active === "dark" ? activeClasses : inactiveClasses
            }`}
            onMouseUp={(e) => {
                ripple === "dark" && rippleEffect.create(e, "dark");
                ripple === "light" && rippleEffect.create(e, "light");
            }}
        >
            {children}
        </li>
    );
}

NavItem.propTypes = {
    children: PropTypes.node.isRequired,
    active: PropTypes.string,
    className: PropTypes.string,
    ripple: PropTypes.string,
};
